<template>
  <span class="alert-status-pill" :class="`alert-status-pill--${status}`">
    <svg v-if="status === 'resolved'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 9.5l3 3 7-7"/></svg>
    {{ meta.label }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { statusMeta } from '@root/services/alertFormat';

// `alert-severity-pills.html`'s lifecycle states — Open/Acknowledged/
// Resolved. A distinct visual family (grey/lavender/green) from the
// severity pills so a resolved-critical alert never reads as
// still-critical at a glance — lifecycle and severity are independent axes.
const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

const meta = computed(() => statusMeta(props.status));
</script>

<style lang="scss">
.alert-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 4px 10px;
  border-radius: 14px;
  white-space: nowrap;

  svg {
    width: 11px;
    height: 11px;
    flex-shrink: 0;
  }

  &--open {
    background: var(--theme-border-soft);
    color: var(--theme-text-secondary);
  }

  &--acknowledged {
    background: #efe6f5;
    color: #6b3e94;
  }

  &--resolved {
    background: #e1f3ea;
    color: #1c7a4d;
  }
}
</style>
